import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { teamsKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function deleteTeam(id: number): Promise<void> {
  await apiClient.url(`/teams/${id}`).delete().res();
}

export function useDeleteTeam(): UseMutationResult<void, Error, number> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteTeam,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: teamsKeys.all });
    },
  });
}
